// Copyright (c) 2019 Verimatrix, Inc.  All Rights Reserved.

import {AREYOUTHERE_TIMER, LOGOUT_TIMER} from '../config'

export const SHOW_ARE_YOU_THERE = 'show_are_you_there'


export function showAreYouThere (show, expiredSession = false) {
  return (dispatch) => {
    dispatch({
      type: SHOW_ARE_YOU_THERE,
      payload: {
        show: show,
        expiredSession: expiredSession
      }
    })
  }
}

export function checkUserActivity () {
  const log_out_time = AREYOUTHERE_TIMER + (LOGOUT_TIMER)

  return (dispatch, getState) => {
    const {user_data} = getState().session

    if (user_data) {
      const now = new Date().getTime()
      const lastUserActivity = getState().areYouThere.lastUserActivity.getTime()

      const {show, expiredSession} = getState().areYouThere

      if ( (now - lastUserActivity) >= AREYOUTHERE_TIMER) {
        if (!show) {
          dispatch(showAreYouThere(true))
        }
      }

      if (now - lastUserActivity >= log_out_time) {
        if (show && !expiredSession) {
          dispatch(showAreYouThere(true, true))
        }
      }
    }
  }
}
